function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgroformLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.9 23.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "formgroup_logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.85,11v7.37H36.34V16.75c-.69,1.17-2,1.8-3.93,1.8-3,0-4.83-1.68-4.83-3.91s1.61-3.87,5.55-3.87h3c0-1.61-1-2.54-3-2.54a6.15,6.15,0,0,0-3.72,1.2L28.06,6.81a9.94,9.94,0,0,1,5.57-1.56C37.57,5.25,39.85,7.08,39.85,11ZM36.1,14.28V13H33.54c-1.76,0-2.31.64-2.31,1.51S32,16,33.34,16A2.76,2.76,0,0,0,36.1,14.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.69,5.44V16.2c0,4.8-2.59,7-7.24,7a10.68,10.68,0,0,1-6.34-1.78l1.49-2.69a7.68,7.68,0,0,0,4.56,1.46C51.8,20.2,53,19,53,16.68v-.56a5.31,5.31,0,0,1-4.08,1.61,6.15,6.15,0,0,1-6.46-6.24,6.15,6.15,0,0,1,6.46-6.24A5.17,5.17,0,0,1,53.14,7.1V5.44ZM53,11.49a3.4,3.4,0,1,0-3.39,3.17A3.14,3.14,0,0,0,53,11.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.19,5.25V8.71a8.21,8.21,0,0,0-.84-.05c-2.06,0-3.43,1.13-3.43,3.6v6.1H60.17V5.44h3.58V7.15A5.21,5.21,0,0,1,68.19,5.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34,11.9c0-3.89,3-6.65,7.11-6.65S83.53,8,83.53,11.9s-3,6.65-7.08,6.65S69.34,15.79,69.34,11.9Zm10.4,0a3.32,3.32,0,1,0-6.61,0,3.32,3.32,0,1,0,6.61,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.61,4.24V5.73H92.5V7.17H88.66V18.36H87V7.17H84.7V5.73H87V4.17A3.47,3.47,0,0,1,90.77.43a4,4,0,0,1,2.52.79l-.57,1.27a2.87,2.87,0,0,0-1.87-.62C89.38,1.87,88.61,2.68,88.61,4.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.32,12a6.42,6.42,0,0,1,12.84,0,6.42,6.42,0,1,1-12.84,0Zm11.11,0a4.7,4.7,0,1,0-9.38,0,4.7,4.7,0,1,0,9.38,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,5.63V7.29l-.41,0c-2.64,0-4.25,1.68-4.25,4.65v6.44h-1.7V5.73h1.63V8.2C112.06,6.52,113.67,5.63,116,5.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.9,11v7.32h-1.7V11.2c0-2.66-1.34-4-3.62-4-2.6,0-4.23,1.68-4.23,4.56v6.63h-1.7V11.2c0-2.66-1.35-4-3.65-4-2.57,0-4.23,1.68-4.23,4.56v6.63h-1.7V5.73h1.63V8a5.1,5.1,0,0,1,4.63-2.41,4.54,4.54,0,0,1,4.49,2.67,5.51,5.51,0,0,1,5-2.67C137.89,5.63,139.9,7.41,139.9,11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "2.77 6.47 2.77 22.32 19.39 12.72 19.39 9.81 5.48 17.84 5.29 17.73 5.29 7.93 2.77 6.47",
    style: {
      fill: "#62ad30"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2.65 0 0.13 1.46 14.03 9.48 14.03 9.7 5.54 14.6 5.54 17.52 19.26 9.59 2.65 0",
    style: {
      fill: "#fdc50d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2.52 22.32 2.52 6.26 2.71 6.15 11.2 11.05 13.72 9.59 0 1.67 0 20.86 2.52 22.32",
    style: {
      fill: "#ae6742"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgroformLogoWhite);
export default __webpack_public_path__ + "static/media/agroform_logo_white.e234626e90122668ba8fac3eb30d56c8.svg";
export { ForwardRef as ReactComponent };